export const SEX_OPTIONS = [
  { value: "uomo", label: "Uomo" },
  { value: "donna", label: "Donna" },
];

export const FORMULA_OPTIONS = [
  { value: "mifflin", label: "Mifflin-St Jeor" },
  { value: "harris", label: "Harris-Benedict" },
  { value: "katch", label: "Katch-McArdle" },
  { value: "ideale", label: "Peso ideale × 24" },
];

export const LAF_OPTIONS = [
  { value: 1.2, label: "Sedentario (poco/nessun esercizio)" },
  { value: 1.375, label: "Leggero (1-3 gg/sett)" },
  { value: 1.55, label: "Moderato (3-5 gg/sett)" },
  { value: 1.725, label: "Intenso (6-7 gg/sett)" },
  { value: 1.9, label: "Molto intenso (2x al giorno)" },
];

export function computeMetrics(p) {
  const peso = parseFloat(p.peso) || 0;
  const alt = parseFloat(p.altezza) || 0;
  const eta = parseFloat(p.eta) || 0;
  const bf = parseFloat(p.massaGrassa) || 0;
  const isM = p.sesso !== "donna";

  const hIn = alt / 2.54;
  const devine = alt > 0 ? (isM ? 50 + 2.3 * (hIn - 60) : 45.5 + 2.3 * (hIn - 60)) : 0;

  let bmr = 0;
  if (p.formula === "ideale") {
    bmr = devine * 24;
  } else if (p.formula === "harris") {
    bmr = isM
      ? 88.362 + 13.397 * peso + 4.799 * alt - 5.677 * eta
      : 447.593 + 9.247 * peso + 3.098 * alt - 4.33 * eta;
  } else if (p.formula === "katch") {
    const lbm = bf > 0 ? peso * (1 - bf / 100) : peso;
    bmr = 370 + 21.6 * lbm;
  } else {
    bmr = 10 * peso + 6.25 * alt - 5 * eta + (isM ? 5 : -161);
  }
  if (bmr < 0) bmr = 0;

  const laf = parseFloat(p.laf) || 1.55;
  const tdee = bmr * laf;

  const hM = alt / 100;
  const bmi = hM > 0 ? peso / (hM * hM) : 0;
  let bmiCat = "—";
  if (bmi > 0) {
    if (bmi < 18.5) bmiCat = "Sottopeso";
    else if (bmi < 25) bmiCat = "Normopeso";
    else if (bmi < 30) bmiCat = "Sovrappeso";
    else bmiCat = "Obesità";
  }

  const lorentz = alt > 0 ? (isM ? alt - 100 - (alt - 150) / 4 : alt - 100 - (alt - 150) / 2) : 0;

  const rangeMin = 18.5 * hM * hM;
  const rangeMax = 24.9 * hM * hM;

  return { bmr, tdee, bmi, bmiCat, devine, lorentz, rangeMin, rangeMax };
}

export function computeMacroGrams(target, carbP, protP, fatP) {
  const t = parseFloat(target) || 0;
  return {
    carbG: (t * (parseFloat(carbP) || 0)) / 100 / 4,
    protG: (t * (parseFloat(protP) || 0)) / 100 / 4,
    fatG: (t * (parseFloat(fatP) || 0)) / 100 / 9,
  };
}

export const MACRO_REF_OPTIONS = [
  { value: "attuale", label: "Peso attuale" },
  { value: "ideale", label: "Peso ideale" },
  { value: "custom", label: "Peso personalizzato" },
];

export function macroRefWeight(patient, m = computeMetrics(patient)) {
  const mc = patient.macro || {};
  if (mc.ref === "ideale") return m.devine || 0;
  if (mc.ref === "custom") return parseFloat(mc.refPeso) || 0;
  return parseFloat(patient.peso) || 0;
}

export function resolveMacros(patient) {
  const mc = patient.macro || {};
  const m = computeMetrics(patient);
  if (mc.mode === "gkg") {
    const w = macroRefWeight(patient, m);
    const carbG = (parseFloat(mc.carbGk) || 0) * w;
    const protG = (parseFloat(mc.protGk) || 0) * w;
    const fatG = (parseFloat(mc.fatGk) || 0) * w;
    return { carbG, protG, fatG, kcal: carbG * 4 + protG * 4 + fatG * 9, refWeight: w };
  }
  const kcal = Math.round(m.tdee);
  return { ...computeMacroGrams(kcal, mc.carbP, mc.protP, mc.fatP), kcal, refWeight: macroRefWeight(patient, m) };
}
